<template>
<div>
    <div v-if="!isMobile">
        
        <div class="div_001">
            <div class="div_001_001">
                <div @click="nav_001('')"></div>
                <div>
                    <div @click="nav_001('Features')">     Features     </div>
                    <div @click="nav_001('Applications')"> Applications </div>
                    <div @click="nav_001('Projects')">     Projects     </div>
                    <div @click="nav_001('About')">        About Us     </div>
                    <div @click="nav_001('Contact')">      Contact Us   </div>
                </div>
                <div>
                    <div></div> <div> EN </div>
                </div>
            </div>
        </div>
        
        <div class="div_002" :style="{ 'height' : screenHeight + 'px' }">
            <div class="div_002_001">
                <div :style="{ 'height' : screenHeight - 120 + 'px' }">
                    <div id="div_002_001_imgs" class="div_002_001_imgs" style="left: 0px;">
                        <div><div></div></div> <div><div></div></div> <div><div></div></div>
                    </div>
                    <div class="div_002_001_l">
                        <span>Learn more</span>
                    </div>
                    <div class="div_002_001_r">
                        <div>
                            <div @click="fun_001(v_active - 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                    <path fill="none" :stroke="v_active == 1 ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)'" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/>
                                </svg>
                            </div>
                            <div @click="fun_001(1)" :class="v_active == 1 ? 'div_active' : '' ">Natural</div>
                            <div @click="fun_001(2)" :class="v_active == 2 ? 'div_active' : '' ">Minimal</div>
                            <div @click="fun_001(3)" :class="v_active == 3 ? 'div_active' : '' ">Durable</div>
                            <div @click="fun_001(v_active + 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                    <path fill="none" :stroke="v_active == 3 ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)'" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                                </svg>
                            </div>
                        </div>
                        <div class="iconfont_002"> Build Your Perfect Place with Minewaytech Panels     </div>
                        <div class="iconfont_002"> — Earth-Extracted, Safe to Live, Kind to the Planet. </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_003">
            <div class="div_003_001">
                <div class="iconfont_002">
                    Outstanding performance with 
                    Comprehensive Strengths
                </div>
                <div>
                    MinewayTech Panel is an inorganic fiber density board. It boasts the impact resistance, non-combustible and water resistance of stone along with natural environmental benefits, and also features the toughness and easy processability of wood
                </div>
                <div>
                    <div> Learn more </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                            <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                        </svg>
                    </div>
                </div>
                <div>
                    <div> <div> <span> 01 </span> <span> Durable         </span> </div> </div>
                    <div> <div> <span> 02 </span> <span> Non-Combustible </span> </div> </div>
                    <div> <div> <span> 03 </span> <span> Waterproof      </span> </div> </div>
                    <div> <div> <span> 04 </span> <span> High toughness  </span> </div> </div>
                    <div> <div> <span> 05 </span> <span> Eco-friendly    </span> </div> </div>
                </div>
            </div>
        </div>
        
        <div class="div_004">
            <div class="div_004_001">
                <div>
                    <div class="iconfont_002">
                        Implementation Cases
                    </div>
                    <div>
                        MinewayTech Panel features extensive usability, being widely applied to interior wall panels, flooring, backing boards and furniture production. Moreover, it can be finished with diverse material textures, serving as an excellent alternative to multiple conventional materials
                    </div>
                    <div>
                        <div> Learn more </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div>
                    <span> Hospital/Laboratory </span> <span> Airports </span> <span> Sports Facilities </span> <span> Commercial Area </span>
                </div>
            </div>
        </div>
        
        <div class="div_005">
            <div class="div_005_001 iconfont_002">
                Featured Projects
            </div>
            <div class="div_005_002">
                <div>
                    <div @click="nav_001('Projects/Project/CBD Fair Booth Project&image_001.png')">
                        <div class="div_005_002_t div_t_first_001"></div>
                        <div class="div_005_002_b div_b_first_001">
                            <div></div> <span> CBD Fair Booth Project </span> <span> | </span> <div></div> <span> Guangzhou </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 02&image_002.png')">
                        <div class="div_005_002_t"></div>
                        <div class="div_005_002_b">
                            <div></div> <span> Case 02 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 03&image_003.png')">
                        <div class="div_005_002_t"></div>
                        <div class="div_005_002_b">
                            <div></div> <span> Case 03 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 04&image_004.png')">
                        <div class="div_005_002_t"></div>
                        <div class="div_005_002_b">
                            <div></div> <span> Case 04 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="div_005_003">
                <div> Learn more </div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                        <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="div_006">
            <div>
                <div></div>
                <div>
                    <div class="iconfont_002"> MinewayTech </div>
                    <div class="iconfont_002"> Your dependable go-to partner for renovation materials </div>
                    <div>
                        The MinewayTech Rock Mineral Panel is a green production line independently developed by Jiaocheng Yiwang Ferroalloy Co., Ltd. Founded in 1988, the company has adhered to the founding philosophy of 'Learning, Research, Innovation' established by its founder, Mr.Song Bingqian, and has evolved into a modern circular economy enterprise leading the industry. With a 1,000-acre site and over 1,500 employees, the company operates a provincial-level new materials R&D center certified by CNAS. Committed to exploring industrial chain extensions, it contributes to China's green ecological industry and circular economy development.
                    </div>
                    <div>
                        <div> Learn more </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_007">
            <div class="scrollbar-slim">
                <div>
                    <div> <div @click="div_show_flag = 1"></div> <div> Environmental Performance </div> </div>
                    <div> <div @click="div_show_flag = 2"></div> <div> Physical Properties </div> </div>
                    <div> <div @click="div_show_flag = 3"></div> <div> Quality Inspection </div> </div>
                    <div> <div @click="div_show_flag = 4"></div> <div> Fire Resistance </div> </div>
                </div>
            </div>
        </div>
        
        <div class="div_007_popup" v-if="div_show_flag != 0" :style="{ 'height' : screenHeight + 'px' }">
            <div class="scrollbar-slim" :style="{ 'height' : screenHeight - 100 + 'px' }">
                
                <div class="div_007_popup_block_001" v-if="div_show_flag == 1">
                    <div> <div @click="div_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_007_popup_block_002" v-if="div_show_flag == 2">
                    <div> <div @click="div_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_007_popup_block_003" v-if="div_show_flag == 3">
                    <div> <div @click="div_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_007_popup_block_004" v-if="div_show_flag == 4">
                    <div> <div @click="div_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
            </div>
        </div>
        
        <div class="div_008">
            <div class="iconfont_002"> News & Updates </div>
            <div>
                <div></div> <div></div> <div></div>
            </div>
        </div>
        
    </div>
    
    <div v-if="isMobile">
         
        <div class="div_mobile_001">
            <div class="div_mobile_001_001">
                <div class="div_mobile_001_001_l" @click="nav_001('')"></div>
                <div class="div_mobile_001_001_r">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div @click="fun_002()"></div>
                </div>
            </div>
        </div>
        
        <div id="div_mobile_menu" class="div_mobile_menu" :style="{ height: screenHeight + 'px', top: -screenHeight + 'px' }">
            <div @click="nav_001('Features')">     Features     </div>
            <div @click="nav_001('Applications')"> Applications </div>
            <div @click="nav_001('Projects')">     Projects     </div>
            <div @click="nav_001('About')">        About Us     </div>
            <div @click="nav_001('Contact')">      Contact Us   </div>
            <div :style="{ 'height' : screenHeight - 438 + 'px' }"  @click="fun_002()"></div>
        </div>
       
        <div class="div_mobile_002">
            <div class="div_mobile_002_001">
                <div>
                    <div id="div_mobile_002_001_imgs" class="div_mobile_002_001_imgs" style="left: 0px;">
                        <div><div></div></div> <div><div></div></div> <div><div></div></div>
                    </div>
                    <div class="div_mobile_002_001_l">
                        <span>Learn more</span>
                    </div>
                    <div class="div_mobile_002_001_r">
                        <div>
                            <div @click="">
                                <!--
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                    <path fill="none" :stroke="v_active == 1 ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)'" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/>
                                </svg>
                                -->
                            </div>
                            <div @click="" :class="m_active == 1 ? 'div_active' : '' ">Natural</div>
                            <div @click="" :class="m_active == 2 ? 'div_active' : '' ">Minimal</div>
                            <div @click="" :class="m_active == 3 ? 'div_active' : '' ">Durable</div>
                            <div @click="">
                                <!--
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                    <path fill="none" :stroke="v_active == 3 ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)'" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                                </svg>
                                -->
                            </div>
                        </div>
                        <div class="iconfont_002"> Build Your Perfect Place with Minewaytech Panels     </div>
                        <div class="iconfont_002"> — Earth-Extracted, Safe to Live, Kind to the Planet. </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_003">
            <div class="div_mobile_003_001">
                <div class="iconfont_002">
                    Outstanding performance with 
                    Comprehensive Strengths
                </div>
                <div>
                    MinewayTech Panel is an inorganic fiber density board. It boasts the impact resistance, non-combustible and water resistance of stone along with natural environmental benefits, and also features the toughness and easy processability of wood
                </div>
                <div>
                    <div> Learn more </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                            <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                        </svg>
                    </div>
                </div>
                <div>
                    <div> <div> <span> 01 </span> <span> Durable         </span> </div> </div>
                    <div> <div> <span> 02 </span> <span> Non-Combustible </span> </div> </div>
                    <div> <div> <span> 03 </span> <span> Waterproof      </span> </div> </div>
                    <div> <div> <span> 04 </span> <span> High toughness  </span> </div> </div>
                    <div> <div> <span> 05 </span> <span> Eco-friendly    </span> </div> </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_004">
            <div class="div_mobile_004_001">
                <div>
                    <div class="iconfont_002">
                        Implementation Cases
                    </div>
                    <div>
                        MinewayTech Panel features extensive usability, being widely applied to interior wall panels, flooring, backing boards and furniture production. Moreover, it can be finished with diverse material textures, serving as an excellent alternative to multiple conventional materials
                    </div>
                    <div>
                        <div> Learn more </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div>
                    <span> Hospital/Laboratory </span> <span> Airports </span> <span> Sports Facilities </span> <span> Commercial Area </span>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_005">
            <div class="div_mobile_005_001 iconfont_002">
                Featured Projects
            </div>
            <div class="div_mobile_005_002">
                <div>
                    <div @click="nav_001('Projects/Project/CBD Fair Booth Project&image_001.png')">
                        <div class="div_mobile_005_002_t div_mobile_t_first_001"></div>
                        <div class="div_mobile_005_002_b ">
                            <div></div> <span> CBD Fair Booth Project </span> <span> | </span> <div></div> <span> Guangzhou </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 02&image_002.png')">
                        <div class="div_mobile_005_002_t"></div>
                        <div class="div_mobile_005_002_b">
                            <div></div> <span> Case 02 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 03&image_003.png')">
                        <div class="div_mobile_005_002_t"></div>
                        <div class="div_mobile_005_002_b">
                            <div></div> <span> Case 03 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                    <div @click="nav_001('Projects/Project/Case 04&image_004.png')">
                        <div class="div_mobile_005_002_t"></div>
                        <div class="div_mobile_005_002_b">
                            <div></div> <span> Case 04 </span> <span> | </span> <div></div> <span> Location </span> <span> | </span> <span> 2025 </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="div_mobile_005_003">
                <div> Learn more </div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                        <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_006">
            <div>
                <div></div>
                <div>
                    <div class="iconfont_002"> MinewayTech </div>
                    <div class="iconfont_002"> Your dependable go-to partner for renovation materials </div>
                    <div>
                        The MinewayTech Rock Mineral Panel is a green production line independently developed by Jiaocheng Yiwang Ferroalloy Co., Ltd. Founded in 1988, the company has adhered to the founding philosophy of 'Learning, Research, Innovation' established by its founder, Mr.Song Bingqian, and has evolved into a modern circular economy enterprise leading the industry. With a 1,000-acre site and over 1,500 employees, the company operates a provincial-level new materials R&D center certified by CNAS. Committed to exploring industrial chain extensions, it contributes to China's green ecological industry and circular economy development.
                    </div>
                    <div>
                        <div> Learn more </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
                                <path fill="none" stroke="#E1B94F" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_007">
            <div class="scrollbar-slim">
                <div>
                    <div> <div @click="div_mobile_show_flag = 1"></div> <div> Environmental Performance </div> </div>
                    <div> <div @click="div_mobile_show_flag = 2"></div> <div> Physical Properties </div> </div>
                    <div> <div @click="div_mobile_show_flag = 3"></div> <div> Quality Inspection </div> </div>
                    <div> <div @click="div_mobile_show_flag = 4"></div> <div> Fire Resistance </div> </div>
                </div>
            </div>
        </div>
        
        <div class="div_mobile_007_popup" v-if="div_mobile_show_flag != 0">
            <div class="scrollbar-slim">
                
                <div class="div_mobile_007_popup_block_001" v-if="div_mobile_show_flag == 1">
                    <div> <div @click="div_mobile_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_mobile_007_popup_block_002" v-if="div_mobile_show_flag == 2">
                    <div> <div @click="div_mobile_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_mobile_007_popup_block_003" v-if="div_mobile_show_flag == 3">
                    <div> <div @click="div_mobile_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
                <div class="div_mobile_007_popup_block_004" v-if="div_mobile_show_flag == 4">
                    <div> <div @click="div_mobile_show_flag = 0"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close </div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                    <div> <div></div> <div></div> </div>
                </div>
                
            </div>
        </div>
        
        <div class="div_mobile_008">
            <div class="iconfont_002"> News & Updates </div>
            <div>
                <div></div> <div></div> <div></div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile             : false,
            screenHeight         : 0,
            scrollTop            : 0,
            
            v_active             : 1,
            m_active             : 1,
            
            div_show_flag        : 0,
            div_mobile_show_flag : 0,
            
            init_move_001        : null,
            init_move_002        : null,
            
            isInitCompleted      : false
        };
    },
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
        
        if ( !this.isMobile ) {
            
            clearInterval( this.init_move_001 );
            clearInterval( this.init_move_002 );
            
            that.init_move_001 = setInterval( () => {
                if ( that.v_active < 3 ) {
                    that.fun_001( that.v_active + 1 );
                } else {
                    that.fun_001( 1 );
                }
            }, 5000 );
            
        } else {
            
            clearInterval( this.init_move_001 );
            clearInterval( this.init_move_002 );
            
            that.init_move_002 = setInterval( () => {
                
                if ( that.m_active < 3 ) {
                    that.fun_mobile_001( that.m_active + 1 );
                } else {
                    that.fun_mobile_001( 1 );
                }
            }, 5000 );
        }
        
        // 初始化完成标志；
        this.isInitCompleted = true;
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
        
        console.log("destroyed");
        
        clearInterval( this.init_move_001 );
        clearInterval( this.init_move_002 );
    },
    watch : {
        // 被监听变量；
        isMobile ( newValue ) {
            
            let that = this;
            
            if (!this.isInitCompleted) return;
            
            console.log( '设备变更：' + newValue );
            
            if ( !newValue ) {
                
                that.v_active = 1;
                
                clearInterval( this.init_move_001 );
                clearInterval( this.init_move_002 );
                
                that.init_move_001 = setInterval( () => {
                    if ( that.v_active < 3 ) {
                        that.fun_001( that.v_active + 1 );
                    } else {
                        that.fun_001( 1 );
                    }
                }, 5000 );
                
            } else {
                
                that.m_active = 1;
                
                clearInterval( this.init_move_001 );
                clearInterval( this.init_move_002 );
                
                that.init_move_002 = setInterval( () => {
                    if ( that.m_active < 3 ) {
                        that.fun_mobile_001( that.m_active + 1 );
                    } else {
                        that.fun_mobile_001( 1 );
                    }
                }, 5000 );
            }
        }
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
        // 事件 - 轮播图切换；
        fun_001( index ) {
            
            if ( this.isMobile ) return;
            
            if ( index < 1 || index > 3 ) return;
            
            this.v_active = index;
            
            if ( index == 1 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从右往左
                    if ( offset < 0 ) {
                        
                        document.getElementById( 'div_002_001_imgs' ).style.left = Number(offset) + 40 + 'px';
                        
                        if( document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0] >= 0 ) {
                            
                            document.getElementById( 'div_002_001_imgs' ).style.left = '0px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
            
            if ( index == 2 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从左往右
                    if ( offset > -1376 ) {
                        
                        document.getElementById( 'div_002_001_imgs' ).style.left = offset - 40 + 'px';
                        
                        if( document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0] <= -1376 ) {
                            
                            document.getElementById( 'div_002_001_imgs' ).style.left = '-1376px';
                            
                            clearInterval( move );
                        }
                    }
                    
                    // 从右往左
                    if ( offset < -1376 ) {
                        
                        document.getElementById( 'div_002_001_imgs' ).style.left = Number(offset) + 40 + 'px';
                        
                        if( document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0] >= -1376 ) {
                            
                            document.getElementById( 'div_002_001_imgs' ).style.left = '-1376px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
            
            if ( index == 3 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从左往右
                    if ( offset > -2752 ) {
                        
                        document.getElementById( 'div_002_001_imgs' ).style.left = offset - 40 + 'px';
                        
                        if( document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0] <= -2752 ) {
                            
                            document.getElementById( 'div_002_001_imgs' ).style.left = '-2752px';
                            
                            clearInterval( move );
                        }
                    }
                    
                    // 从右往左
                    if ( offset < -2752 ) {
                        
                        document.getElementById( 'div_002_001_imgs' ).style.left = Number(offset) + 40 + 'px';
                        
                        if( document.getElementById( 'div_002_001_imgs' ).style.left.split('px')[0] >= -2752 ) {
                            
                            document.getElementById( 'div_002_001_imgs' ).style.left = '-2752px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
        },
        
        // 事件 - 移动端轮播图切换；
        fun_mobile_001( index ) {
            
            if ( !this.isMobile ) return;
            
            if ( index < 1 || index > 3 ) return;
            
            this.m_active = index;
            
            if ( index == 1 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从右往左
                    if ( offset < 0 ) {
                        
                        document.getElementById( 'div_mobile_002_001_imgs' ).style.left = Number(offset) + 5 + 'px';
                        
                        if( document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0] >= 0 ) {
                            
                            document.getElementById( 'div_mobile_002_001_imgs' ).style.left = '0px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
            
            if ( index == 2 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从左往右
                    if ( offset > -330 ) {
                        
                        document.getElementById( 'div_mobile_002_001_imgs' ).style.left = offset - 5 + 'px';
                        
                        if( document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0] <= 330 ) {
                            
                            document.getElementById( 'div_mobile_002_001_imgs' ).style.left = '-330px';
                            
                            clearInterval( move );
                        }
                    }
                    
                    // 从右往左
                    if ( offset < -330 ) {
                        
                        document.getElementById( 'div_mobile_002_001_imgs' ).style.left = Number(offset) + 5 + 'px';
                        
                        if( document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0] >= -330 ) {
                            
                            document.getElementById( 'div_mobile_002_001_imgs' ).style.left = '-330px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
            
            if ( index == 3 ) {
                var move = setInterval( () => {
                    
                    let offset = document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0];
                    
                    // 从左往右
                    if ( offset > -660 ) {
                        
                        document.getElementById( 'div_mobile_002_001_imgs' ).style.left = offset - 5 + 'px';
                        
                        if( document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0] <= -660 ) {
                            
                            document.getElementById( 'div_mobile_002_001_imgs' ).style.left = '-660px';
                            
                            clearInterval( move );
                        }
                    }
                    
                    // 从右往左
                    if ( offset < -660 ) {
                        
                        document.getElementById( 'div_mobile_002_001_imgs' ).style.left = Number(offset) + 5 + 'px';
                        
                        if( document.getElementById( 'div_mobile_002_001_imgs' ).style.left.split('px')[0] >= -660 ) {
                            
                            document.getElementById( 'div_mobile_002_001_imgs' ).style.left = '-660px';
                            
                            clearInterval( move );
                        }
                    }
                    
                }, 0 );
            }
        },
        // 事件 - 移动端导航栏；
        fun_002( ) {
            
            let that = this;
            
            let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
            
            clearInterval( menu_move );
            
            console.log(offset);
            
            if ( offset < 0 ) {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) + 6 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] >= 0 ) {
                        
                        document.getElementById( 'div_mobile_menu' ).style.top = '0px';
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            } else {
                
                var menu_move = setInterval( () => {
                    
                    let offset = Number(document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0]);
                    
                    document.getElementById( 'div_mobile_menu' ).style.top = Number(offset) - 6 + 'px';
                    
                    if( document.getElementById( 'div_mobile_menu' ).style.top.split('px')[0] <= -that.screenHeight ) {
                    
                        document.getElementById( 'div_mobile_menu' ).style.top = -that.screenHeight;
                        
                        clearInterval( menu_move );
                    }
                    
                }, 0 );
                
            }
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_001 {
    width: 100%;
    height: 88px;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_001_001 {
    width: 1440px;
    height: 100%;
    
    background-color: #F7F4EC;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_001_001 > div:first-child {
    width: 137px;
    height: 32px;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_000.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: absolute;
    top: 28px;
    left: 32px;
}

.div_001_001 > div:nth-child(2) {
    width: 885px;
    
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_001 > div:nth-child(2) > div {
    cursor: pointer;
}

.div_001_001 > div:last-child {
    width: 54px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 32px;
    right: 32px;
}

.div_001_001 > div:last-child > div:first-child {
    width: 20px;
    height: 20px;
    
    background-image : url('../assets/image_000_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
    top: 0.5px;
}

.div_001_001 > div:last-child > div:last-child {
    font-size: 16px;
    font-weight: 500;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_002 {
    width: 100%;
}

.div_002_001 {
    width: 1440px;
    height: 100%;
    
    padding-top: 88px;
    padding-bottom: 32px;
    
    margin: 0 auto;
}

.div_002_001 > div {
    width: 1376px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    overflow : hidden;
    
    position: relative;
}

.div_002_001_imgs {
    width: 4128px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_002_001_imgs > div > div {
    width: 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.15);
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_002_001_imgs > div:first-child ,
.div_002_001_imgs > div:nth-child(2),
.div_002_001_imgs > div:last-child  {
    width: 1376px;
    height: 100%;
    
    border-radius: 10px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    overflow : hidden;
}

.div_002_001_imgs > div:first-child {
    background-image : url('../assets/image_001_001.jpg');
    left: 0;
}

.div_002_001_imgs > div:nth-child(2) {
    background-image : url('../assets/image_001_002.jpg');
    left: 1376px;
}

.div_002_001_imgs > div:last-child {
    background-image : url('../assets/image_001_003.jpg');
    left: 2752px;
}

.div_002_001_l {
    width : 400px;
    height: 140px;
    
    color: #2F2F2F;
    font-size: 16px;
    font-weight: 500;
    
    background-color: #F7F4EC;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_002_001_l > span {
    margin-bottom: 5px;
    cursor: pointer;
}

.div_002_001_r {
    width: 648px;
    height: 157px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
    
    position: absolute;
    bottom: 47px;
    right: 50px;
}

.div_002_001_r > div:first-child {
    width: 357px;
    height: 50px;
    
    font-size: 16px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: absolute;
    top: 0px;
    right: 0px;
}

.div_002_001_r > div:first-child > div {
    height: 100%;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_002_001_r > div:first-child > div:first-child,
.div_002_001_r > div:first-child > div:last-child {
    width: 16px;
    height: 16px;
}

.div_002_001_r > div:first-child > div:first-child > svg,
.div_002_001_r > div:first-child > div:last-child  > svg {
    width: 16px;
    height: 16px;
}

.div_002_001_r > div:nth-child(2) {
    width: 100%;
    height: 36px;
    
    font-size: 24px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-end;
    align-items : center;
}

.div_002_001_r > div:last-child {
    width: 100%;
    height: 36px;
    
    font-size: 24px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-end;
    align-items : center;
}

.div_active {
    color: #E1B94F;
    border-bottom: 1px solid #E1B94F;
}

/*** ************************************************* ***/

.div_003 {
    width: 100%;
    height: 936px;
    
    background-color: #151513;
}

.div_003_001 {
    width: 1440px;
    height: 936px;
    
    margin: 0 auto;
    
    color: #F7F4EC;
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_003_001 > div:first-child {
    width: 563px;
    height: 104px;
    
    font-size: 36px;
    
    margin-top: 64px;
    
    text-align: center;
}

.div_003_001 > div:nth-child(2) {
    width: 942px;
    height: 48px;
    
    font-size: 15px;
    font-weight: 400;
    
    margin-top: 32px;
    
    text-align: left;
}

.div_003_001 > div:nth-child(3) {
    width: 124px;
    height: 24px;
    
    cursor: pointer;
    
    margin-top: 32px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_003_001 > div:nth-child(3) > div:first-child {
    width: 88px;
    
    font-size: 16px;
    font-weight: 500;
    
    line-height: 24px;
}

.div_003_001 > div:nth-child(3) > div:last-child {
    width: 24px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : self-end;
}

.div_003_001 > div:nth-child(3) > div:last-child > svg {
    width: 18px;
    height: 18px;
}

.div_003_001 > div:last-child {
    width: 100%;
    height: 560px;
    
    margin-top: 72px;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

.div_003_001 > div:last-child > div {
    width: 288px;
    height: 100%;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 130%;
    
    position: relative;
}

.div_003_001 > div:last-child > div:first-child {
    background-image : url('../assets/image_002_001.png');
}

.div_003_001 > div:last-child > div:nth-child(2) {
    background-image : url('../assets/image_002_002.png');
}

.div_003_001 > div:last-child > div:nth-child(3) {
    background-image : url('../assets/image_002_003.png');
}

.div_003_001 > div:last-child > div:nth-child(4) {
    background-image : url('../assets/image_002_004.png');
}

.div_003_001 > div:last-child > div:last-child {
    background-image : url('../assets/image_002_005.png');
}

.div_003_001 > div:last-child > div > div {
    width: 100%;
    height: 100%;
    
    background-color: rgba(47, 47, 47, 0.4);
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_003_001 > div:last-child > div > div > span:first-child {
    width: 239px;
    height: 24px;
    
    font-size: 16px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_003_001 > div:last-child > div > div > span:last-child {
    width: 239px;
    height: 36px;
    
    font-size: 24px;
    
    margin: 5px 0px 33px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_004 {
    width: 100%;
    height: 936px;
}

.div_004_001 {
    width: 1440px;
    height: 936px;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
}

.div_004_001 > div:first-child {
    width: 427px;
    height: 265px;
    
    margin-right: 72px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_004_001 > div:first-child > div:first-child {
    width: 100%;
    height: 52px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
    
    font-size: 36px;
}

.div_004_001 > div:first-child > div:nth-child(2) {
    width: 100%;
    height: 120px;
        
    font-size: 16px;
    
    margin-top: 35px;
    
    text-align: justify;
}

.div_004_001 > div:first-child > div:last-child {
    width: 124px;
    height: 24px;
    
    font-size: 16px;
    
    margin-top: 35px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_004_001 > div:first-child > div:last-child > div:first-child {
    width: 88px;
    
    font-size: 16px;
    font-weight: 500;
    
    line-height: 24px;
}

.div_004_001 > div:first-child > div:last-child > div:last-child {
    width: 24px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : self-end;
}

.div_004_001 > div:first-child > div:last-child > div:last-child > svg {
    width: 18px;
    height: 18px;
}

.div_004_001 > div:last-child {
    width: 877px;
    height: 796px;
    
    font-size: 20px;
    color: #F7F4EC;
    
    background-image : url('../assets/image_003_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_004_001 > div:last-child > span {
    cursor: pointer;
}

.div_004_001 > div:last-child > span:first-child {
    position: absolute;
    top: 20px;
    left: 30px;
}

.div_004_001 > div:last-child > span:nth-child(2) {
    position: absolute;
    top: 20px;
    right: 30px;
}

.div_004_001 > div:last-child > span:nth-child(3) {
    position: absolute;
    bottom: 20px;
    left: 30px;
}

.div_004_001 > div:last-child > span:last-child {
    position: absolute;
    bottom: 20px;
    right: 30px;
}

/*** ************************************************* ***/

.div_005 {
    width: 100%;
    height: 715px;
    
    color: #F7F4EC;
    background-color: #2F2F2F;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_005_001 {
    width: 313px;
    height: 52px;
    
    font-size: 36px;
    
    margin-top: 60px;
}

@keyframes scroll_001 {
  0% { transform: translateX(0); }
  100% { transform: translateX(-30%); }
}

.div_005_002 {
    width: 1440px;
    height: 384px;
    
    margin-top: 60px;
    
    overflow-x: scroll;
}

.div_005_002::-webkit-scrollbar {
    display: none;
}

.div_005_002 > div {
    width: 1888px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    animation: scroll_001 10s linear infinite;
}

.div_005_002 > div:hover {
    animation-play-state: paused;
}

.div_005_002 > div > div {
    width: 448px;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_005_002_t {
    width: 448px;
    height: 384px;
    
    border-radius: 8px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_005_002 > div > div:first-child > .div_005_002_t {
    background-image : url('../assets/image_005_001.png');
}

.div_005_002 > div > div:nth-child(2) > .div_005_002_t {
    background-image : url('../assets/image_005_002.png');
}

.div_005_002 > div > div:nth-child(3) > .div_005_002_t {
    background-image : url('../assets/image_005_003.png');
}

.div_005_002 > div > div:last-child > .div_005_002_t {
    background-image : url('../assets/image_005_004.png');
}

.div_005_002_b {
    width: 70%;
    height: 24px;
    
    margin-top: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    align-self: flex-start;
}

.div_t_first_001 {
    border-radius: 12px;
    background-size : 145% !important;
}

.div_b_first_001 {
    width: 90% !important;
}

.div_005_002_b > div:first-child {
    width: 24px;
    height: 24px;
    
    background-image : url('../assets/04 Projects/icon_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_005_002_b > div:nth-child(4) {
    width: 24px;
    height: 24px;
    
    background-image : url('../assets/04 Projects/icon_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 70%;
}

.div_005_003 {
    width: 124px;
    
    font-size: 16px;
    margin-top: 60px;
    
    line-height: 24px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_005_003 > div:first-child {
    cursor: pointer;
}

.div_005_003 > div:last-child {
    width: 24px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_005_003 > div:last-child > svg {
    width: 18px;
    height: 18px;
}

/*** ************************************************* ***/

.div_006 {
    width: 100%;
    height: 936px;
    
    background-color: #151513;
}

.div_006 > div {
    width: 1440px;
    height: 936px;
    
    margin: 0px auto;
    
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_006 > div > div:first-child {
    width: 881px;
    height: 936px;
    
    background-image : url('../assets/image_006_001.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 160%;
}

.div_006 > div > div:last-child {
    width: 527px;
    height: 623px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_006 > div > div:last-child > div {
    width: 100%;
    
    text-align: left;
}

.div_006 > div > div:last-child > div:first-child {
    font-size: 36px;
    /* font-weight: 600; */
}

.div_006 > div > div:last-child > div:nth-child(2) {
    font-size: 36px;
    /* font-weight: 600; */
    margin-top: 24px;
}

.div_006 > div > div:last-child > div:nth-child(3) {
    font-size: 16px;
    margin-top: 64px;
    text-align: justify;
}

.div_006 > div > div:last-child > div:last-child {
    width: 124px;
    
    font-size: 16px;
    margin-top: 64px;
    
    line-height: 24px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_006 > div > div:last-child > div:last-child > div:first-child {
    cursor: pointer;
}

.div_006 > div > div:last-child > div:last-child > div:last-child {
    width: 24px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_006 > div > div:last-child > div:last-child > div:last-child > svg {
    width: 18px;
    height: 18px;
}

/*** ************************************************* ***/

.div_007 {
    width: 100%;
    height: 671px;
    
    background-color: #2F2F2F;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_007 > div {
    width: 1440px;
    height: 543px;
    
    overflow-x: scroll;
}

/* .div_007 > div::-webkit-scrollbar {
    display: none;
} */

.div_007 > div > div {
    width: 1596px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_007 > div > div > div {
    width: 357px;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_007 > div > div > div > div:first-child {
    width: 357px;
    height: 490px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_007 > div > div > div:first-child  > div:first-child { background-image : url('../assets/01 Environmental Performance/image_001.jpg'); }
.div_007 > div > div > div:nth-child(2) > div:first-child { background-image : url('../assets/01 Physical Properties/image_001.jpg'); }
.div_007 > div > div > div:nth-child(3) > div:first-child { background-image : url('../assets/01 Quality Inspection/image_001.jpg'); }
.div_007 > div > div > div:last-child   > div:first-child { background-image : url('../assets/01 Fire Resistance/image_001.jpg'); }

.div_007 > div > div > div > div:last-child {
    width: 357px;
    height: 30px;
    
    color: #F7F4EC;
    font-size: 20px;
    
    cursor: pointer;
    
    margin-top: 10px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_007_popup {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0.9);
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0;
    left: 0;
    
    z-index: 99999999;
}

.div_007_popup > div {
    width: 1440px;
    
    overflow-x: scroll;
}

.div_007_popup_block_001 ,
.div_007_popup_block_002 ,
.div_007_popup_block_003 ,
.div_007_popup_block_004 {
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_007_popup_block_001 > div ,
.div_007_popup_block_002 > div ,
.div_007_popup_block_003 > div ,
.div_007_popup_block_004 > div {
    width: 500px;
    height: 786px;
    
    margin: 0px 16px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

/* Close */
.div_007_popup_block_001 > div > div:first-child ,
.div_007_popup_block_002 > div > div:first-child ,
.div_007_popup_block_003 > div > div:first-child ,
.div_007_popup_block_004 > div > div:first-child {
    width: 500px;
    height: 30px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/* Close */
.div_007_popup_block_001 > div:first-child > div:first-child ,
.div_007_popup_block_002 > div:first-child > div:first-child ,
.div_007_popup_block_003 > div:first-child > div:first-child ,
.div_007_popup_block_004 > div:first-child > div:first-child {
    width: 500px;
    height: 30px;
    
    font-size: 16px;
    color: #F7F4EC;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_007.png');
    background-repeat : no-repeat;
    background-position : 1% 50%;
    background-size : 3%;
}

.div_007_popup_block_001 > div > div:last-child ,
.div_007_popup_block_002 > div > div:last-child ,
.div_007_popup_block_003 > div > div:last-child ,
.div_007_popup_block_004 > div > div:last-child {
    width: 500px;
    height: 706px;
    
    margin-top: 5px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_007_popup_block_001 > div:first-child  > div:last-child { background-image : url('../assets/01 Environmental Performance/image_001.jpg'); }
.div_007_popup_block_001 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Environmental Performance/image_002.jpg'); }
.div_007_popup_block_001 > div:last-child   > div:last-child { background-image : url('../assets/01 Environmental Performance/image_003.jpg'); }

.div_007_popup_block_002 > div:first-child  > div:last-child { background-image : url('../assets/01 Physical Properties/image_001.jpg'); }
.div_007_popup_block_002 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Physical Properties/image_002.jpg'); }
.div_007_popup_block_002 > div:last-child   > div:last-child { background-image : url('../assets/01 Physical Properties/image_003.jpg'); }

.div_007_popup_block_003 > div:first-child  > div:last-child { background-image : url('../assets/01 Quality Inspection/image_001.jpg'); }
.div_007_popup_block_003 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Quality Inspection/image_002.jpg'); }
.div_007_popup_block_003 > div:last-child   > div:last-child { background-image : url('../assets/01 Quality Inspection/image_003.jpg'); }

.div_007_popup_block_004 > div:first-child  > div:last-child { background-image : url('../assets/01 Fire Resistance/image_001.jpg'); }
.div_007_popup_block_004 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Fire Resistance/image_002.jpg'); }
.div_007_popup_block_004 > div:nth-child(3) > div:last-child { background-image : url('../assets/01 Fire Resistance/image_003.jpg'); }
.div_007_popup_block_004 > div:last-child   > div:last-child { background-image : url('../assets/01 Fire Resistance/image_004.jpg'); }

/*** ************************************************* ***/

.div_008 {
    width: 100%;
    height: 612px;
    
    background-color: #F7F4EC;
}

.div_008 > div:first-child {
    width: 427px;
    height: 52px;
    
    font-size: 36px;
    font-weight: 600;
    
    margin: 64px auto 0px;
    
    background-color: #F7F4EC;
}

.div_008 > div:last-child {
    width: 1376px;
    height: 400px;
    
    margin: 64px auto 0;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
}

.div_008 > div:last-child > div {
    width: 400px;
    height: 400px;
    
    border-radius: 10px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : top;
    background-size : 100%;
}

.div_008 > div:last-child > div:first-child {
    background-image : url('../assets/image_008_001.jpg');
}

.div_008 > div:last-child > div:nth-child(2) {
    background-image : url('../assets/image_008_002.png');
}

.div_008 > div:last-child > div:last-child {
    background-image : url('../assets/image_008_003.png');
    background-position : 50% 47%;
}

/*** ************************************************* ***/
/*** ************************************************* ***/

.div_mobile_001 {
    width: 100%;
    height: 88px;
    
    background-color: #F7F4EC;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: fixed;
    top: 0px;
    
    z-index: 9999999;
}

.div_mobile_001_001 {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_001_l {
    width: 137px;
    height: 32px;
    
    background-image : url('../assets/image_000_000.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_001_r {
    width: 40px;
    height: 40px;
    
    background-color: #2F2F2F;
    
    border-radius: 4px;
        
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_mobile_001_001_r > div {
    width: 28px;
    height: 3px;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: #F7F4EC;
}

.div_mobile_001_001_r > div:last-child {
    width: 100%;
    height: 100%;
    
    margin-top: 2.5px;
    margin-bottom: 2.5px;
    
    border-radius: 2px;
    
    background-color: transparent;
    
    position: absolute;
}

.div_mobile_menu {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    left: 0px;
    
    z-index: 999999;
}

.div_mobile_menu > div {
    width: 100%;
    height: 70px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
    
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    background-color: #F7F4EC;
}

.div_mobile_menu > div:first-child {
    margin-top: 88px;
}

.div_mobile_menu > div:last-child {
    width: 100%;
    
    background-color: rgba(0, 0, 0, 0);
}

/*** ************************************************* ***/

.div_mobile_002 {
    width: 100%;
    height: 608px;
}

.div_mobile_002_001 {
    width: 90%;
    
    padding-top: 88px;
    padding-bottom: 32px;
    
    margin: 0 auto;
}

.div_mobile_002_001 > div {
    width: 90%;
    height: 500px;
    
    margin: 0 auto;
    border-radius: 10px;
    
    overflow : hidden;
    
    position: relative;
}

.div_mobile_002_001_imgs {
    width: 990px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_mobile_002_001_imgs > div > div {
    width: 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.15);
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_mobile_002_001_imgs > div:first-child ,
.div_mobile_002_001_imgs > div:nth-child(2),
.div_mobile_002_001_imgs > div:last-child  {
    width: 90%;
    height: 100%;
    
    border-radius: 10px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 250%;
    
    overflow : hidden;
}

.div_mobile_002_001_imgs > div:first-child {
    background-image : url('../assets/image_001_001.jpg');
    left: 0;
}

.div_mobile_002_001_imgs > div:nth-child(2) {
    background-image : url('../assets/image_001_002.jpg');
    left: 660px;
}

.div_mobile_002_001_imgs > div:last-child {
    background-image : url('../assets/image_001_003.jpg');
    left: 990px;
}

.div_mobile_002_001_l {
    width : 250px;
    height: 100px;
    
    color: #2F2F2F;
    font-size: 10px;
    font-weight: 500;
    
    background-color: #F7F4EC;
    
    clip-path: polygon(0 0, 0 100%, 100% 100%);
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-end;
    
    position: absolute;
    bottom: 0;
    left: 0;
}

.div_mobile_002_001_l > span {
    margin-bottom: 5px;
    cursor: pointer;
}

.div_mobile_002_001_r {
    width: 300px;
    height: 157px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
    
    position: absolute;
    bottom: 50px;
    right: 0px;
}

.div_mobile_002_001_r > div:first-child {
    width: 290px;
    height: 50px;
    
    font-size: 14px;
    color: #F7F4EC;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
    
    position: absolute;
    top: 0px;
    right: -35px;
}

.div_mobile_002_001_r > div:first-child > div {
    height: 100%;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_002_001_r > div:first-child > div:first-child,
.div_mobile_002_001_r > div:first-child > div:last-child {
    width: 16px;
    height: 16px;
}

.div_mobile_002_001_r > div:first-child > div:first-child > svg,
.div_mobile_002_001_r > div:first-child > div:last-child  > svg {
    width: 16px;
    height: 16px;
}

.div_mobile_002_001_r > div:nth-child(2) {
    width: 250px;
    height: 36px;
    
    font-size: 11px;
    color: #F7F4EC;
    
    margin-right: 10px;
    margin-bottom: 10px;
    
    text-align: right;
    
    align-self: flex-end;
}

.div_mobile_002_001_r > div:last-child {
    width: 230px;
    height: 36px;
    
    font-size: 11px;
    color: #F7F4EC;
    
    margin-right: 10px;
    margin-bottom: 0px;
    
    text-align: right;
    
    align-self: flex-end;
}

.div_active {
    color: #E1B94F;
    border-bottom: 1px solid #E1B94F;
}

/*** ************************************************* ***/

.div_mobile_003 {
    width: 100%;
    
    background-color: #151513;
}

.div_mobile_003_001 {
    width: 90%;
    
    margin: 0 auto;
    
    color: #F7F4EC;
    background-color: #151513;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_003_001 > div:first-child {
    width: 90%;
    font-size: 20px;
    margin-top: 40px;
    text-align: center;
}

.div_mobile_003_001 > div:nth-child(2) {
    width: 90%;
    
    font-size: 12px;
    font-weight: 400;
    
    margin-top: 20px;
    
    text-align: justify;
}

.div_mobile_003_001 > div:nth-child(3) {
    width: 124px;
    height: 24px;
    
    cursor: pointer;
    
    margin-top: 30px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_003_001 > div:nth-child(3) > div:first-child {
    width: 100px;
    
    font-size: 14px;
    font-weight: 500;
    
    line-height: 24px;
}

.div_mobile_003_001 > div:nth-child(3) > div:last-child {
    width: 24px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : self-end;
}

.div_mobile_003_001 > div:nth-child(3) > div:last-child > svg {
    width: 18px;
    height: 18px;
}

.div_mobile_003_001 > div:last-child {
    width: 100%;
    height: 700px;
    
    margin-top: 40px;
    margin-bottom: 20px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_003_001 > div:last-child > div {
    width: 100%;
    height: 100%;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_mobile_003_001 > div:last-child > div:first-child {
    background-image : url('../assets/image_002_001.png');
}

.div_mobile_003_001 > div:last-child > div:nth-child(2) {
    background-image : url('../assets/image_002_002.png');
}

.div_mobile_003_001 > div:last-child > div:nth-child(3) {
    background-image : url('../assets/image_002_003.png');
}

.div_mobile_003_001 > div:last-child > div:nth-child(4) {
    background-image : url('../assets/image_002_004.png');
}

.div_mobile_003_001 > div:last-child > div:last-child {
    background-image : url('../assets/image_002_005.png');
}

.div_mobile_003_001 > div:last-child > div > div {
    width: 100%;
    height: 100%;
    
    background-color: rgba(47, 47, 47, 0.4);
    
    display : flex;
    flex-direction : column;
    justify-content : flex-end;
    align-items : center;
    
    position: absolute;
    top: 0;
    left: 0;
}

.div_mobile_003_001 > div:last-child > div > div > span:first-child {
    width: 239px;
    height: 24px;
    
    font-size: 16px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_003_001 > div:last-child > div > div > span:last-child {
    width: 239px;
    height: 36px;
    
    font-size: 24px;
    
    margin: 5px 0px 33px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_004 {
    width: 100%;
}

.div_mobile_004_001 {
    width: 90%;
    
    margin: 0 auto;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div:first-child {
    width: 100%;
    
    height: 260px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_004_001 > div:first-child > div:first-child {
    width: 100%;
    
    font-size: 22px;
    
    margin-top: 40px;
    
    text-align: center;
}

.div_mobile_004_001 > div:first-child > div:nth-child(2) {
    width: 100%;
        
    font-size: 12px;
    
    margin-top: 35px;
    
    text-align: justify;
}

.div_mobile_004_001 > div:first-child > div:last-child {
    width: 124px;
    height: 24px;
    
    font-size: 12px;
    
    margin-top: 25px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_004_001 > div:first-child > div:last-child > div:first-child {
    width: 70px;
    
    font-size: 12px;
    font-weight: 500;
    
    line-height: 24px;
    
    text-align: left;
}

.div_mobile_004_001 > div:first-child > div:last-child > div:last-child {
    width: 24px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : self-end;
}

.div_mobile_004_001 > div:first-child > div:last-child > div:last-child > svg {
    width: 18px;
    height: 18px;
}

.div_mobile_004_001 > div:last-child {
    width: 100%;
    height: 300px;
    
    font-size: 14px;
    color: #F7F4EC;
    
    margin-bottom: 20px;
    
    background-image : url('../assets/image_003_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
    
    position: relative;
}

.div_mobile_004_001 > div:last-child > span {
    cursor: pointer;
}

.div_mobile_004_001 > div:last-child > span:first-child {
    position: absolute;
    top: 10px;
    left: 10px;
}

.div_mobile_004_001 > div:last-child > span:nth-child(2) {
    position: absolute;
    top: 10px;
    right: 10px;
}

.div_mobile_004_001 > div:last-child > span:nth-child(3) {
    position: absolute;
    bottom: 10px;
    left: 10px;
}

.div_mobile_004_001 > div:last-child > span:last-child {
    position: absolute;
    bottom: 10px;
    right: 10px;
}

/*** ************************************************* ***/

.div_mobile_005 {
    width: 100%;
    
    color: #F7F4EC;
    background-color: #2F2F2F;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_005_001 {
    width: 313px;
    height: 40px;
    
    font-size: 22px;
    
    margin-top: 40px;
}

@keyframes scroll_002 {
  0% { transform: translateX(0); }
  100% { transform: translateX(-70%); }
}

.div_mobile_005_002 {
    width: 90%;
    margin: 40px auto 0;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

.div_mobile_005_002::-webkit-scrollbar {
    display: none;
}

.div_mobile_005_002 > div {
  width: -webkit-max-content;
  width: max-content;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  
  /* 无限滚动 */
  animation: scroll_002 15s linear infinite;
}

.div_mobile_005_002 > div:hover {
    animation-play-state: paused;
}

.div_mobile_005_002 > div > div {
    width: 200px;
    height: 220px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_005_002_t {
    width: 200px;
    height: 184px;
    
    border-radius: 8px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_005_002 > div > div:first-child > .div_mobile_005_002_t {
    background-image : url('../assets/image_005_001.png');
}

.div_mobile_005_002 > div > div:nth-child(2) > .div_mobile_005_002_t {
    background-image : url('../assets/image_005_002.png');
}

.div_mobile_005_002 > div > div:nth-child(3) > .div_mobile_005_002_t {
    background-image : url('../assets/image_005_003.png');
}

.div_mobile_005_002 > div > div:last-child > .div_mobile_005_002_t {
    background-image : url('../assets/image_005_004.png');
}

.div_mobile_005_002_b {
    width: 200px;
    height: 24px;
    
    font-size: 10px;
    margin-top: 10px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    align-self: flex-start;
}

.div_mobile_t_first_001 {
    border-radius: 12px;
    background-size : 160% !important;
}

.div_mobile_005_002_b > div:first-child {
    width: 16px;
    height: 16px;
    
    background-image : url('../assets/04 Projects/icon_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_005_002_b > span:nth-child(2) ,
.div_mobile_005_002_b > span:nth-child(5) {
    overflow : hidden;
    text-overflow : ellipsis; /* 超出部分显示省略号；*/
    white-space : nowrap;     /* 控制当前文本不换行；*/
}

.div_mobile_005_002_b > div:nth-child(4) {
    width: 16px;
    height: 16px;
    
    background-image : url('../assets/04 Projects/icon_002.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 70%;
}

.div_mobile_005_003 {
    width: 110px;
    
    font-size: 12px;
    line-height: 24px;
    
    margin-top: 30px;
    margin-bottom: 30px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-around;
    align-items : center;
}

.div_mobile_005_003 > div:last-child {
    width: 24px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_005_003 > div:last-child > svg {
    width: 16px;
    height: 16px;
}

/*** ************************************************* ***/

.div_mobile_006 {
    width: 100%;
    
    background-color: #151513;
}

.div_mobile_006 > div {
    width: 90%;
    
    margin: 0px auto;
    
    color: #F7F4EC;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_006 > div > div:first-child {
    width: 90%;
    height: 340px;
    
    margin-top: 40px;
    margin-bottom: 30px;
    
    background-image : url('../assets/image_006_001.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 155%;
}

.div_mobile_006 > div > div:last-child {
    width: 90%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_006 > div > div:last-child > div {
    width: 100%;
    
    text-align: left;
}

.div_mobile_006 > div > div:last-child > div:first-child {
    font-size: 22px;
    /* font-weight: 600; */
}

.div_mobile_006 > div > div:last-child > div:nth-child(2) {
    font-size: 22px;
    /* font-weight: 600; */
    margin-top: 24px;
}

.div_mobile_006 > div > div:last-child > div:nth-child(3) {
    font-size: 12px;
    margin-top: 36px;
    text-align: justify;
}

.div_mobile_006 > div > div:last-child > div:last-child {
    width: 100px;
    
    font-size: 12px;
    margin-top: 30px;
    margin-bottom: 10px;
    
    line-height: 24px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_006 > div > div:last-child > div:last-child > div:last-child {
    width: 24px;
    height: 24px;
    
    cursor: pointer;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_006 > div > div:last-child > div:last-child > div:last-child > svg {
    width: 18px;
    height: 18px;
}

/*** ************************************************* ***/

.div_mobile_007 {
    width: 100%;
    height: 630px;
    
    background-color: #2F2F2F;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_007 > div {
    width: 90%;
    height: 500px;
    
    overflow-x: scroll;
}

/* .div_mobile_007 > div::-webkit-scrollbar {
    display: none;
} */

.div_mobile_007 > div > div {
    width: 1596px;
    height: 100%;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_007 > div > div > div {
    width: 90%;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_007 > div > div > div > div:first-child {
    width: 90%;
    height: 490px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_007 > div > div > div:first-child  > div:first-child { background-image : url('../assets/01 Environmental Performance/image_001.jpg'); }
.div_mobile_007 > div > div > div:nth-child(2) > div:first-child { background-image : url('../assets/01 Physical Properties/image_001.jpg'); }
.div_mobile_007 > div > div > div:nth-child(3) > div:first-child { background-image : url('../assets/01 Quality Inspection/image_001.jpg'); }
.div_mobile_007 > div > div > div:last-child   > div:first-child { background-image : url('../assets/01 Fire Resistance/image_001.jpg'); }

.div_mobile_007 > div > div > div > div:last-child {
    width: 357px;
    height: 30px;
    
    color: #F7F4EC;
    font-size: 20px;
    
    cursor: pointer;
    
    margin-top: 10px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_007_popup {
    width: 100%;
    height: 100%;
    
    background-color: rgba(0, 0, 0, 0.9);
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    position: fixed;
    top: 0;
    left: 0;
    
    z-index: 99999999;
}

.div_mobile_007_popup > div {
    width: 100%;
    height: 1500px;
    
    margin-top: 30px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
    
    overflow: scroll;
}

.div_mobile_007_popup_block_001 ,
.div_mobile_007_popup_block_002 ,
.div_mobile_007_popup_block_003 ,
.div_mobile_007_popup_block_004 {
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

.div_mobile_007_popup_block_001 > div ,
.div_mobile_007_popup_block_002 > div ,
.div_mobile_007_popup_block_003 > div ,
.div_mobile_007_popup_block_004 > div {
    width: 300px;
    height: 486px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : center;
}

/* Close */
.div_mobile_007_popup_block_001 > div > div:first-child ,
.div_mobile_007_popup_block_002 > div > div:first-child ,
.div_mobile_007_popup_block_003 > div > div:first-child ,
.div_mobile_007_popup_block_004 > div > div:first-child {
    width: 300px;
    height: 30px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : center;
}

/* Close */
.div_mobile_007_popup_block_001 > div:first-child > div:first-child ,
.div_mobile_007_popup_block_002 > div:first-child > div:first-child ,
.div_mobile_007_popup_block_003 > div:first-child > div:first-child ,
.div_mobile_007_popup_block_004 > div:first-child > div:first-child {
    width: 300px;
    height: 30px;
    
    font-size: 16px;
    color: #F7F4EC;
    
    cursor: pointer;
    
    background-image : url('../assets/image_000_007.png');
    background-repeat : no-repeat;
    background-position : 1% 50%;
    background-size : 3%;
}

.div_mobile_007_popup_block_001 > div > div:last-child ,
.div_mobile_007_popup_block_002 > div > div:last-child ,
.div_mobile_007_popup_block_003 > div > div:last-child ,
.div_mobile_007_popup_block_004 > div > div:last-child {
    width: 300px;
    height: 406px;
    
    margin-top: 15px;
    margin-bottom: 15px;
    
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_007_popup_block_001 > div:first-child  > div:last-child { background-image : url('../assets/01 Environmental Performance/image_001.jpg'); }
.div_mobile_007_popup_block_001 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Environmental Performance/image_002.jpg'); }
.div_mobile_007_popup_block_001 > div:last-child   > div:last-child { background-image : url('../assets/01 Environmental Performance/image_003.jpg'); }

.div_mobile_007_popup_block_002 > div:first-child  > div:last-child { background-image : url('../assets/01 Physical Properties/image_001.jpg'); }
.div_mobile_007_popup_block_002 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Physical Properties/image_002.jpg'); }
.div_mobile_007_popup_block_002 > div:last-child   > div:last-child { background-image : url('../assets/01 Physical Properties/image_003.jpg'); }

.div_mobile_007_popup_block_003 > div:first-child  > div:last-child { background-image : url('../assets/01 Quality Inspection/image_001.jpg'); }
.div_mobile_007_popup_block_003 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Quality Inspection/image_002.jpg'); }
.div_mobile_007_popup_block_003 > div:last-child   > div:last-child { background-image : url('../assets/01 Quality Inspection/image_003.jpg'); }

.div_mobile_007_popup_block_004 > div:first-child  > div:last-child { background-image : url('../assets/01 Fire Resistance/image_001.jpg'); }
.div_mobile_007_popup_block_004 > div:nth-child(2) > div:last-child { background-image : url('../assets/01 Fire Resistance/image_002.jpg'); }
.div_mobile_007_popup_block_004 > div:nth-child(3) > div:last-child { background-image : url('../assets/01 Fire Resistance/image_003.jpg'); }
.div_mobile_007_popup_block_004 > div:last-child   > div:last-child { background-image : url('../assets/01 Fire Resistance/image_004.jpg'); }

/*** ************************************************* ***/

.div_mobile_008 {
    width: 100%;
    
    background-color: #F7F4EC;
}

.div_mobile_008 > div:first-child {
    width: 90%;
    
    font-size: 22px;
    font-weight: 600;
    
    margin: 30px auto 0px;
    
    background-color: #F7F4EC;
}

.div_mobile_008 > div:last-child {
    width: 90%;
    height: 980px;
    
    margin: 20px auto 20px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : center;
}

.div_mobile_008 > div:last-child > div {
    width: 300px;
    height: 300px;
    
    border-radius: 10px;
    
    cursor: pointer;
    
    background-repeat : no-repeat;
    background-position : top;
    background-size : 100%;
}

.div_mobile_008 > div:last-child > div:first-child {
    background-image : url('../assets/image_008_001.jpg');
}

.div_mobile_008 > div:last-child > div:nth-child(2) {
    background-image : url('../assets/image_008_002.png');
}

.div_mobile_008 > div:last-child > div:last-child {
    background-image : url('../assets/image_008_003.png');
    background-position : 50% 47%;
}

/*** ************************************************* ***/
</style>